import type { DisplayPrefs } from '@aiax-hub/contracts';
import { useSavePrefs } from '../api/preferences';
import { useT } from '../i18n';
import { useViewStore } from '../state/store';
import { toast } from '../ui/layers';
import { useAuth } from './AuthContext';

/** Sign-in controls stay local; signed-in controls save the same account preferences as /me. */
export function useDisplaySettings() {
  const { me } = useAuth();
  const save = useSavePrefs();
  const t = useT();
  return (display: Partial<Pick<DisplayPrefs, 'lang' | 'theme'>>, done?: () => void) => {
    if (!me) { useViewStore.getState().apply(display); done?.(); return; }
    save.mutate({ display }, { onSuccess: done, onError: () => toast(t('me.err.prefs'), 'danger') });
  };
}
